/*
 * Behaviour that used to live in on*= attributes, driven by data- attributes
 * instead. An inline handler is script the content policy has to allow page by
 * page (script-src-attr), and several of these interpolated a template value
 * inside a JS string: HTML escaping does not protect that, because the browser
 * decodes the entity before the handler runs.
 *
 *   <form data-confirm="Revoke {{name}}?">       confirm() before submitting
 *   <select data-autosubmit>                     submit its form on change
 *   <select data-nav-param="page">               navigate to ?page=<value>
 *
 * The listeners are delegated from document, in the capture phase, so the
 * confirm runs before any form-level handler and a cancel stops them all.
 */

export function installDeclarativeActions(root = document) {
  root.addEventListener(
    'submit',
    (ev) => {
      const form = ev.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-confirm')) {
        return;
      }
      if (!window.confirm(form.dataset.confirm)) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
      }
    },
    true,
  );

  root.addEventListener('change', (ev) => {
    const el = ev.target;
    if (!(el instanceof HTMLSelectElement)) {
      return;
    }
    if (el.hasAttribute('data-autosubmit') && el.form) {
      el.form.submit();
      return;
    }
    const param = el.dataset.navParam;
    if (param) {
      const url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set(param, el.value);
      window.location.href = url.toString();
    }
  });
}
